import { LAccordion, Loader } from "@components";
import { useApi } from "@services/useApi";
import { Role } from "@store/generalTypes";
import { useCallback, useEffect, useState } from "react";
import { PermissionList } from "../components/permissionList";

export const RolesPermissions = (): JSX.Element => {
    const [isLoading, setIsLoading] = useState(true);
    const [roles, setRoles] = useState<Role[]>([]);

    const { getRoles } = useApi();

    useEffect(() => {
        void laodRoles();
    }, []);

    const laodRoles = useCallback(async () => {
        const data = await getRoles();
        setRoles(data);
        setIsLoading(false);
    }, []);

    if (isLoading) {
        return <Loader />;
    }

    return (
        <>
            <h1 className="title is-5 mt-5">System Roles</h1>
            <div
                className="columns has-text-weight-bold has-background-grey-lighter m-0 pl-4"
                style={{
                    borderTopLeftRadius: "6px",
                    borderTopRightRadius: "6px"
                }}
            >
                <div className="column is-one-fifth">Role</div>
                <div className="column ml-4">Description</div>
            </div>
            {roles.map((x, i) => (
                <LAccordion
                    key={x.id}
                    title={
                        <div className="columns">
                            <div className="column is-one-fifth">{x.name}</div>
                            <div className="column">{x.description}</div>
                        </div>
                    }
                    isLast={i === roles.length - 1}
                >
                    <PermissionList permissions={x.permissions} />
                </LAccordion>
            ))}
        </>
    );
};
